<template>
    <div class="image-create-header">
        <a-input v-model:value="searchInput" allow-close :placeholder="fy.holder" class="w-400px">
            <template #suffix>
                <SvgIcon name="search" class="text-[#8c8c8c]" />
            </template>
        </a-input>
        <a-button @click="router.push({ name: 'ComputeLabImageCreate' })" type="primary">{{ fy.act.add }}</a-button>
    </div>
    <div class="image-con" v-loading="loading">
        <a-table v-show="!loading" :columns="columns" :data-source="searchResulImageList" :pagination="false" :scroll="{ x: 1000, y: 1000 }">
            <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'image_name'">
                    <a-tooltip>
                        <template #title> {{ `${record.image_name}:${record.image_tag}` }} </template>
                        {{ `${record.image_name}:${record.image_tag}` }}
                    </a-tooltip>
                </template>
                <template v-if="column.dataIndex === 'image_url'">
                    <a-tooltip>
                        <template #title> {{ record.image_url }} </template>
                        {{ record.image_url }}
                    </a-tooltip>
                </template>
                <template v-if="column.dataIndex === 'state'">
                    <div class="states-con flex items-center">
                        <div class="icon w-[8px] h-[8px] mr-6px" :style="{ backgroundColor: StatusMap.get(record.state)?.color, borderRadius: '4px' }"></div>
                        <div class="state-text" :style="{ color: StatusMap.get(record.state)?.color }">{{ StatusMap.get(record.state)?.value }}</div>
                    </div>
                </template>
                <template v-if="column.dataIndex === 'created_at'">
                    {{ convertUtcToLocal(record.created_at) }}
                </template>

                <template v-if="column.key === 'action'">
                    <a-space size="middle">
                        <a-button v-if="record.state === ImageStatus.DISABLE" :disabled="record.state !== ImageStatus.DISABLE" type="link" class="!p-0" @click="handlOperate({ operate: 'enable', imageId: record.image_id })">{{ fy.act.enable }}</a-button>
                        <a-button v-else :disabled="record.state !== ImageStatus.AVAILABLE" type="link" class="!p-0" @click="handlOperate({ operate: 'disable', imageId: record.image_id })">{{ fy.act.disable }}</a-button>
                        <!-- <a-button type="link" class="!p-0" @click="handleOpenTerminal(record)"> Rename </a-button> -->
                        <p type="link" class="!p-0 color-[#EA0000] cursor-pointer" @click="handlOperate({ operate: 'delete', imageId: record.image_id })">{{ fy.act.delete }}</p>
                    </a-space>
                </template>
            </template>
        </a-table>
    </div>
</template>

<script lang="tsx" setup>import { computed as _computed } from 'vue';

    import { ref, onMounted, computed } from 'vue';
    import { useRouter } from 'vue-router';
    import { getComputeLabCustomImageListApi, OperateComputeLabImageApi } from '@/api/image';
    import { ImageStatus, StatusMap } from './data';
    import { Modal } from 'ant-design-vue';
    import { convertUtcToLocal } from '@/utils/time';
    import { useI18n } from '@/locales/useI18n';

    const fy = _computed(() => useI18n().tm('mBooster.image'))
    const router = useRouter();
    const searchInput = ref('');
    defineOptions({
        name: 'PublicTable',
    });
    interface ImageItem {
        imageName: string;
        mainlySoftware: string;
        resourceType: string;
        size: string;
    }
    const columns = [
        {
            dataIndex: 'image_name',
            // width: 120,
            ellipsis: true,
        },
        {
            dataIndex: 'image_url',
            // width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'state',
            width: 160,
        },
        {
            dataIndex: 'created_at',
            width: 180,
        },
        {
            key: 'action',
            // fixed: 'right',
            width: 180,
        },
    ].map((el, idx) => {
        return {
            ...el,
            title: fy.value.cusTHead[idx]
        }
    });

    const imagesList = ref<Array<ImageItem>>([]);
    const loading = ref(false);
    const getCustomImageList = async () => {
        try {
            loading.value = true;
            const res = await getComputeLabCustomImageListApi({ queryName: '' });
            imagesList.value = res as Array<ImageItem>;
        } finally {
            loading.value = false;
        }
    };
    const searchResulImageList = computed(() => {
        if (searchInput.value.trim() === '') {
            return imagesList.value;
        }
        return imagesList.value.filter((item: any) => {
            return `${item.image_name}:${item.image_tag}`.indexOf(searchInput.value) !== -1;
        });
    });
    onMounted(() => {
        getCustomImageList();
    });
    const handlOperate = async ({ operate, imageId }: any) => {
        if (operate === 'enable') {
            await OperateComputeLabImageApi({ operate, imageId });
            getCustomImageList();
            return;
        }
        const modal = Modal.confirm({
            title: fy.value.ask.title(operate),
            content: fy.value.ask.text,
            okText: operate === 'delete' ? fy.value.act.delete : fy.value.ask.confirm,
            cancelText: fy.value.ask.cancel,
            wrapClassName: 'custom-confirm-modal',
            okButtonProps: {
                danger: operate === 'delete',
            },
            centered: true,
            icon: null,
            onOk: async () => {
                try {
                    modal.update({
                        okButtonProps: {
                            loading: true,
                        },
                    });
                    await OperateComputeLabImageApi({ operate, imageId });
                    getCustomImageList();
                } catch (error) {
                    console.log(error);
                } finally {
                    modal.update({
                        okButtonProps: {
                            loading: false,
                        },
                    });
                }
            },
        });
    };
</script>
<style lang="less" scoped>
    .image-create {
        &-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        :deep(.ant-btn-link:not(:disabled):hover) {
            color: none;
        }
    }
</style>
